export default function typeToDetail(type: string): string {
  if (type === 'image' || type === 'css' || type === 'js') return 'assets_all';
  if (type === 'internal' || type === 'external') return 'links';
  return 'internal';
}
